import { useParams } from 'react-router-dom';
import customHeaders, { getSpace } from '../../common/headers';
import { useState, useEffect, useRef } from 'react';
import { TableBox, DropDownSelector, Tabs } from '@lk-gtcom/ecomlab-components';
import { useDataTable } from '../../common/hooks';
import useGeneralStore from '../../store/general';
import './ViewСompetitors2.scss';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { fetchFilterCompetitorsView } from '../../common/filtersFunc';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { RequestController } from '../../common/filtersFunc';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { usePushNotifications } from '../../common/pushNotification';
import { msToLocalDate } from '../../common/constant';
import { periodWeek } from '../../common/constant';
import { useResponseHandler } from '../../common/auth';
import { useSavedFilters } from '../../common/useSavedFilters';

const btn_tab = [
  { label: 'По товарам', value: 'by_product' },
  { label: 'Товары конкурентов', value: 'competitors_products' },
  { label: 'Вертикальный анализ', value: 'vertical_analysis' },
  { label: 'Горизонтальный анализ', value: 'horizontal_analysis' }
];

const type_metric = [
  { label: 'Цена', value: 'price' },
  { label: 'Цена с картой', value: 'price_with_card' },
  { label: 'Остаток', value: 'remaining' },
  { label: 'Рейтинг', value: 'rating' },
  { label: 'Отзывы', value: 'reviews' }
];

const ViewСompetitors2 = ({ }) => {

  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved, hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'view-competitors-2');
  const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
  const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications();

  // Рефы
  const activeTab = useParams()['*']

  // Конфигурация фильтров для URL параметров
  const filterConfig = [
    { key: 'api', type: 'multi' },
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
    { key: 'metric', type: 'single' },
    // { key: 'date_from', type: 'date' },
    // { key: 'date_to', type: 'date' }
  ];

  const requestControllerRef = useRef(new RequestController());
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);

  const [pageValue, setPageValue] = useState(btn_tab[0]?.value);

  // Состояния для дат
  const [date, setDate] = useState(periodWeek());
  const [dateFrom, dateTo] = date;

  // Состояния для пагинации
  const [apiPage, setApiPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);

  // Состояния для поисковых запросов
  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');

  // Данные для фильтров
  const [apiData, setApiData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);

  // Выбранные значения фильтров
  const [selectedMp, setSelectedMp] = useState({ label: 'Ozon', value: 1 });
  const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedMetricsType, setSelectedMetricsType] = useState(null);

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0)

  // Флаг для отслеживания первой инициализации из URL
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  // Метрики для таблицы 
  const [metricsTable, setMetricsTable] = useState([])
  const [selectedMetricsTable, setSelectedMetricsTable] = useState([])
  const [isLoadingMetricsTable, setIsLoadingMetricsTable] = useState(false)

  // Фильтры 
  const [filterValue, setFilterValue] = useState([]);
  const [isModalFilter, setIsModalFilter] = useState(false);

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort, setCustomHeaders } = setTableFuncs;

  // Инициализация фильтров из URL параметров при первом рендере
  useEffect(() => {
    if (!isReady) return;
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.api) setSelectedApi(urlParams.api);
        if (urlParams.category) setSelectedCategory(urlParams.category);
        if (urlParams.brand) setSelectedBrand(urlParams.brand);
        if (urlParams.metric) setSelectedMetricsType(urlParams.metric);
        // if (urlParams.date_from) {
        //   setDate([
        //     new Date(parseInt(urlParams.date_from)),
        //     new Date(parseInt(urlParams.date_to)),
        //   ]);
        // }
        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady]);

  useEffect(() => {
    if (!isReady) return;
    updateURL({
      mp: urlParams?.mp || selectedMp,
      api: urlParams?.api || selectedApi,
      category: urlParams?.category || selectedCategory,
      brand: urlParams?.brand || selectedBrand,
      metric: urlParams?.metric || selectedMetricsType,
      // date_from: urlParams?.date_from || dateFrom,
      // date_to: urlParams?.date_to || dateTo,
    })
  }, [isReady]);

  useEffect(() => {
    if (!isReady) return;
    const abortController = new AbortController();
    if (isInitialized) {
      if (selectedApi?.value && selectedMp?.value) {
        fetchTableData([], abortController);
      } else {
        resetTable()
      }
    }
    return () => abortController.abort();
  }, [isTableRequest]);

  // Остальные функции фильтров остаются без изменений
  const filtersApi = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchFilterCompetitorsView({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalApi,
      page: apiPage,
      setApiData: setApiData,
      set: setApiData,
      searchParam: apiQuery,
      selectedApi,
      filter: 'mp_name',
    })?.finally(() => {
      requestControllerRef.current.removeController('mp_name');
    })
  };

  const filtersCategory = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchFilterCompetitorsView({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalCategory,
      page: categoryPage,
      apiData,
      selectedApi,
      selectedCategory,
      set: setCategoryData,
      setCategoryData: (e) => setCategoryData(e),
      searchParam: categoryQuery,
      selectedShop: selectedApi,
      filter: 'category_name',
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  };

  const filtersBrand = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchFilterCompetitorsView({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalBrand,
      apiData,
      categoryData,
      selectedApi,
      selectedCategory,
      page: brandPage,
      searchParam: brandQuery,
      selectedShop: selectedApi,
      set: setBrandData,
      setBrandData: (e) => setBrandData(e),
      filter: 'brand_name',
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  };

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersApi();
  }, [isFilterRequest, date, apiPage, apiQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersCategory();
  }, [isFilterRequest, date, categoryPage, categoryQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersBrand();
  }, [isFilterRequest, date, brandPage, brandQuery]);

  useEffect(() => {
    return () => {
      requestControllerRef.current.abortAll();
    };
  }, []);

  const resetTable = () => {
    paginatorRef.current.reset();
    paginatorRef.current.setTotal(0);
    setSort({});
    setHeaders([]);
    setFetchedData([]);
  };

  // Обработчик сброса фильтров
  const handleResetFilters = () => {
    setSelectedApi([]);
    setSelectedCategory([]);
    setSelectedBrand([]);
    updateURL({
      api: null,
      category: null,
      brand: null
    });
    setIsTableRequest(!isTableRequest);
    setIsFilterRequest(!isFilterRequest)
    resetTable();
  };

  // Метрики для таблицы price
  const fetchMetricCardTable = () => {
    setIsLoadingMetricsTable(true)
    let url = `https://apps1.ecomru.ru:4450/api/v2/competitors_view/pivot/metrics/competitors_by_days`;

    fetch(url, { method: 'GET', headers: headers })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((error) => {
            throw new Error(`Error: ${error.default || response.statusText}`);
          });
        }
        return response.json();
      })
      .then((data) => {
        if (data && Array.isArray(data)) {
          setMetricsTable(data);
          setSelectedMetricsTable(data?.[0] ? [data?.[0].value] : [])
        }
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setIsLoadingMetricsTable(false)
      });
  };

  // Таблица товаров для ИИ анализа
  const fetchTableData = (params, abortController = new AbortController()) => {
    if (selectedMetricsTable?.length < 1) {
      resetTable()
      return
    }
    let sort;
    let filtersParam = [];

    if (params) {
      [sort, filtersParam] = params;
    }
    const [date_from, date_to] = date;

    // Устанавливаем loading в true только если запрос не прерван
    if (!abortController.signal.aborted) {
      setLoading(true);
    }

    let url = `https://apps1.ecomru.ru:4450/api/v2/competitors_view/pivot/table/competitors_by_days?${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''}`;

    const body = JSON.stringify({
      page: paginatorRef.current?.page,
      limit: paginatorRef.current?.limit,
      filters: filtersParam,
      metrics: selectedMetricsTable,
      date_from: msToLocalDate(date_from),
      date_to: msToLocalDate(date_to),
      mp_name_list: getValueMultiFilter(selectedApi),
      category_name_list: getValueMultiFilter(selectedCategory),
      brand_name_list: getValueMultiFilter(selectedBrand),
      offer_id_list: filterValue,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (!abortController.signal.aborted) {
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    setPageValue(activeTab)
  }, [activeTab])

  useEffect(() => {
    fetchMetricCardTable()
  }, []);

  useEffect(() => {
    const abortController = new AbortController();
    fetchTableData([], abortController)
    return () => abortController.abort();
  }, [isTableRequest, filterValue, date, selectedMetricsTable]);


  return (
    <div className="view-competitors">
      <TitlePage
        title='Посмотреть конкурентов'
      />
      <div className="view-competitors__toolbar">
        <FilterContainer
          loading={isSaved}
          saveFilters={saveFilters}
          clearSavedFilters={clearSavedFilters}
          hasSavedFilters={hasSavedFilters}
          onReset={handleResetFilters}
        >
          <DropDownSelector
            options_prop={apiData}
            state={selectedApi}
            setState={setSelectedApi}
            placeholder="Магазин"
            total={totalApi}
            fetchCallback={setApiPage}
            setInputChange={setApiQuery}
            onBlur={(e) => {
              updateURL({ api: selectedApi });
              filtersCategory();
              filtersBrand();
              setIsTableRequest(!isTableRequest)
            }}
          />

          <DropDownSelector
            options_prop={[]}
            state={[]}
            setState={() => { }}
            placeholder="Продавец"
            onBlur={(e) => {
              setIsTableRequest(!isTableRequest)
            }}
          />

          <DropDownSelector
            options_prop={categoryData}
            state={selectedCategory}
            setState={setSelectedCategory}
            placeholder="Категория"
            total={totalCategory}
            multi={true}
            fetchCallback={setCategoryPage}
            setInputChange={setCategoryQuery}
            onBlur={(e) => {
              updateURL({ category: selectedCategory });
              filtersBrand();
              setIsTableRequest(!isTableRequest)
            }}
          />

          <DropDownSelector
            options_prop={brandData}
            state={selectedBrand}
            setState={setSelectedBrand}
            placeholder="Бренд"
            total={totalBrand}
            multi={true}
            fetchCallback={setBrandPage}
            setInputChange={setBrandQuery}
            onBlur={(e) => {
              updateURL({ brand: selectedBrand });
              setIsTableRequest(!isTableRequest)
            }}
          />

          {pageValue === 'by_product' && <DropDownSelector
            options_prop={type_metric}
            state={selectedMetricsType}
            setState={setSelectedMetricsType}
            placeholder="Тип метрики"
            total={type_metric?.length}
            onBlur={(e) => {
              updateURL({ metric: selectedMetricsType });
              setIsTableRequest(!isTableRequest)
            }}
          />}
        </FilterContainer>

        {/* <RangeBox
          date={date}
          setDate={(e) => {
            const [newDateFrom, newDateTo] = e;
            updateURL({
              date_from: newDateFrom,
              date_to: newDateTo
            });
            setDate(e)
          }}
        /> */}
      </div>

      <Tabs
        tabs={btn_tab}
        pageValue={pageValue}
      />

      {/* <MetricCards
        loading={isLoadingMetricsTable}
        metrics={metricsTable}
        selectedValues={selectedMetricsTable}
        onSelectionChange={setSelectedMetricsTable}
      /> */}

      <TableBox
        {...tableProps}
        paginator
        ref={paginatorRef}
        fetchCallback={fetchTableData}
      />
    </div>
  );
};

export { ViewСompetitors2 };
